<app-hero
	[title]="'support.postBuy.title' | translate"
	subtitle=""
	imageDesktop="assets/hero/assistenza.jpg"
	imageMobile="assets/hero/assistenza_mobile.jpg"
></app-hero>

<div class="container-xxl mh-500">
	<button
		(click)="goBack()"
		class="nav-btn left text-uppercase mobile-only mt-4"
	>
		<mat-icon>chevron_left</mat-icon>{{ "vehicle.button.back" | translate }}
	</button>

	<!-- SERVICES -->
	@if (user?.idMarket === "IT") {
		<div class="leasys-header">
			<h1 class="leasys-title">
				{{ "bolli-pratiche.p1" | translate }}
			</h1>

			<p class="leasys-subtitle"></p>
		</div>

		<div class="services-grid">
			<!-- PRATICHE AUTO -->
			<div class="service-card">
				<img
					src="assets/icons/document.svg"
					alt=""
					class="vehicle-document-icon"
				/>

				<div class="service-content">
					<div class="section-title">{{ "pratiche-auto.p1" | translate }}</div>
					<p class="mb-0">{{ "pratiche-auto.p2" | translate }}</p>
					<span
						(click)="openBooklet()"
						class="ck-link ps-0"
					>
						{{ "homepage.scopiDiPiu" | translate }}
					</span>
				</div>
			</div>

			<!-- SCADENZA BOLLO -->
			<div class="service-card">
				<img
					src="assets/icons/money.svg"
					alt=""
					class="vehicle-document-icon"
				/>
				<div class="service-content">
					<div class="section-title">{{ "scadenza-bollo.p1" | translate }}</div>
					<p class="mb-0">{{ "scadenza-bollo.p2" | translate }}</p>
					<a
						href="https://easydrive.fcagroup.com/servizi/area-leasys.aspx"
						target="_blank"
						class="ck-link ps-0"
					>
						{{ "scadenza-bollo.p3" | translate }}
					</a>
				</div>
			</div>
		</div>
	}

	<!-- REFERENCE INFO -->
	<div class="leasys-header">
		<h1 class="leasys-title">
			{{ "myLeasys.infoSeller" | translate }}
		</h1>

		<p class="leasys-subtitle"></p>
	</div>

	<!-- SELLER -->
	<div class="reference-block">
		<div class="section-title">
			{{ "myLeasys.referenceSeller.title" | translate }}
		</div>

		<div class="reference-card">
			<span> {{ seller?.name }} {{ seller?.surname }} </span>
			<span>
				<img
					src="assets/icons/phone.svg"
					alt=""
					style="width: 25px"
				/>
				{{ seller?.mobile }}
			</span>
			<span>
				<img
					src="assets/icons/email.svg"
					alt=""
					style="width: 25px"
				/>
				{{ seller?.email }}
			</span>
		</div>
	</div>

	<!-- AREA MANAGER -->
	<div class="reference-block">
		<div class="section-title">
			{{ "myLeasys.manager.title" | translate }}
		</div>

		<div class="reference-card">
			<span> {{ seller?.adminName }} {{ seller?.adminSurname }} </span>
			<span>
				<img
					src="assets/icons/phone.svg"
					alt=""
					style="width: 25px"
				/>
				{{ seller?.adminMobile }}
			</span>
			<span>
				<img
					src="assets/icons/email.svg"
					alt=""
					style="width: 25px"
				/>
				{{ seller?.adminEmail }}
			</span>
		</div>
	</div>

	<!-- NOTES -->
	<div class="notes-block">
		<div class="section-title">
			{{ "myLeasys.referenceSeller.note" | translate }}
		</div>
		<br />

		<div
			class="leasys-subtitle"
			[innerHTML]="seller?.note | safeHtml"
		></div>
	</div>
</div>